module.exports = __webpack_public_path__ + "img/live_detail_icon1.d4e9f94a.png";